import { MaintenanceWindow } from "@/components/MaintenanceWindow";
import { getMaintenanceModeMessage } from "@/features/Maintenance/flag";

export function AppMaintenanceWindow() {
  return (
    <MaintenanceWindow
      title="Unavailable for maintenance"
      subtitle={getMaintenanceModeMessage()}
      sx={{ flex: 1, minHeight: 0, height: "100vh" }}
    />
  );
}
